<template>
  <el-card>
    <div class="toolbar">
      <el-button type="primary" @click="onCreateItem">
        <i class="fas fa-fw fa-plus"></i> 新增产品
      </el-button>
      <div class="former">
        <el-input
          v-model="form['Name:like']"
          placeholder="产品名称"
          @keydown.enter.native="onSubmitQuery"
        ></el-input
        >&nbsp;
        <select2
          v-model="form.BusinessTypeID"
          url="basic?type=BusinessType"
          placeholder="请选择业务类型"
          noDataText="无类型"
        ></select2
        >&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table
      :data="itemList"
      v-loading="loading"
      size="medium"
      tooltip-effect="light"
    >
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * pager.page).toString().length * 12)"
      />
      <el-table-column
        prop="BusinessType.Name"
        label="业务类型" width="120"
      ></el-table-column>
      <el-table-column prop="Name" label="产品名称" />
      <el-table-column prop="LatestVersion.Version" label="最新版本号" width="120" />
      <el-table-column label="审核状态" width="100">
        <template slot-scope="scope" v-if="scope.row.LatestVersion">
          <el-tag v-if="scope.row.LatestVersion.CheckStatus === 1" type="info"
            >未审核</el-tag
          >
          <el-tag
            v-if="scope.row.LatestVersion.CheckStatus === 2"
            type="success"
            >已审核</el-tag
          >
          <el-tag
            v-if="scope.row.LatestVersion.CheckStatus === 3"
            type="warning"
            >审核未通过</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="LatestVersion.VersionFunctions"
        label="包含功能版本" width="150"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.LatestVersion">
            <div v-if="scope.row.LatestVersion.VersionFunctions">
              <div
                v-for="func in scope.row.LatestVersion.VersionFunctions"
                :key="func.ID"
              >
                <div>{{ func.Name }}</div>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="LatestVersion.CommProtocols" label="通讯协议" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="scope.row.LatestVersion">
            <div v-if="scope.row.LatestVersion.CommProtocols">
              <div
                v-for="CommProtocol in scope.row.LatestVersion.CommProtocols"
                :key="CommProtocol.ID"
              >
                <div>{{ CommProtocol.Name }}</div>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="225" label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click.stop="onUpdatePack(scope.row)"
            title="发布新版本"
          >
            <i class="fas fa-cloud-upload-alt"></i>
          </el-button>
          <el-button
            type="primary"
            @click.stop="onSeeItem(scope.row)"
            title="查看版本更新记录"
          >
            <i class="fas fa-eye"></i>
          </el-button>
          <el-button
            type="primary"
            @click.stop="onUpdateService(scope.row)"
            title="发布更新程序"
          >
            <i class="fas fa-upload"></i>
          </el-button>
          <el-button
            type="primary"
            @click.stop="onEditItem(scope.row)"
            title="编辑"
          >
            <i class="fas fa-pencil-alt"></i>
          </el-button>
          <el-button
            type="danger"
            @click.stop="onDeleteItem(scope.row)"
            title="删除"
            :disabled="scope.row.LatestVersion !== null"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      ></el-pagination>
    </div>
    <item-form
      v-model="item"
      :visible.sync="itemVisible"
      @form:saved="getItemList"
    />
    <update-pack
      v-model="item"
      :visible.sync="updateVisible"
      @form:saved="getItemList"
    />
  </el-card>
</template>

<script>
import ItemForm from "./index--form.vue";
import UpdatePack from "../update/index--form.vue";

export default {
  components: {
    ItemForm,
    UpdatePack,
  },
  data() {
    return {
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      form: {
        "Name:like": "",
        BusinessTypeID: "",
      },
      item: this.getEmptyItem(),
      itemVisible: false,
      updateVisible: false,
    };
  },
  mounted() {},
  created() {
    this.getItemList();
  },
  methods: {
    getItemList() {
      this.loading = true;
      this.$axios
        .get("software", {
          params: {
            where: this.form,
            with: ["Versions", "Classification", "BusinessType"],
            Main: 2,
            ...this.pager,
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onCreateItem() {
      this.item = this.getEmptyItem();
      this.itemVisible = true;
    },
    getEmptyItem() {
      return {
        Name: "",
        Type: "",
      };
    },
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    onEditItem(row) {
      this.item = row;
      this.itemVisible = true;
    },
    onDeleteItem(row) {
      this.$confirm("确定要删除此软件吗？", "提示")
        .then(() => this.$axios.delete(`software/${row.ID}`))
        .then(() => {
          this.getItemList();
          this.$message.success("成功删除分组");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    onUpdatePack(row) {
      this.item.SoftWareID = row.ID;
      this.updateVisible = true;
    },
    onSeeItem(row) {
      this.$router.push({ name: "SwUpdateDetail", params: { ID: row.ID } });
    },
    onUpdateService(row) {
      this.$router.push({ name: "SwService", params: { ID: row.ID }, query: { softwareName: row.Name } });
    },
  },
};
</script>
